import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import styles from './NavigationBar.module.scss';
import Box from '@/components/UI/box/Box';
import BottomNavigation from '@/components/layout/NavigationBar/bottomNavigation/BottomNavigation';
import DownloadBanner from '@/components/layout/NavigationBar/downloadBanner/DownloadBanner';
import MapMobileButton from '@/components/layout/NavigationBar/mapMobileButton/MapMobileButton';
import MidtermGoftinoButton from './midtermGoftinoButton/MidtermGoftinoButton';
import { useRouter } from 'next/router';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
interface NavigationBarProps {
  isShowMap?: boolean;
  setIsShowMap?: Dispatch<SetStateAction<boolean>>;
  setShowMidtermGoftino?: Dispatch<SetStateAction<boolean>>;
}
const NavigationBar = ({
  isShowMap,
  setIsShowMap,
  setShowMidtermGoftino
}: NavigationBarProps) => {
  const [isShow, setIsShow] = useState(true);
  const [showDownloadBanner, setShowDownloadBanner] = useState(false);
  const router = useRouter();
  const isMidTerm = router.query.mid_term === '1';
  const isWhiteLabel = useIsWhiteLabel();
  useScrollPosition(({
    currPos,
    prevPos
  }) => {
    const isDownThePage = prevPos.y * -1 + 1200 > document.body.clientHeight;
    if (isDownThePage || isShowMap) {
      setIsShow(false);
    } else {
      setIsShow(prevPos.y < currPos.y);
    }
  });
  useEffect(() => {
    setIsShow(!isShowMap);
  }, [isShowMap]);
  return <Box className={`${styles['container']} ${isShow ? styles['show'] : ''}`} data-sentry-element="Box" data-sentry-component="NavigationBar" data-sentry-source-file="NavigationBar.tsx">
      {setIsShowMap && <MapMobileButton isShowMap={isShowMap as boolean} showDownloadBanner={showDownloadBanner} onToggle={() => setIsShowMap(prev => !prev)} />}
      {isMidTerm && setShowMidtermGoftino && <MidtermGoftinoButton showDownloadBanner={showDownloadBanner} onToggle={() => setShowMidtermGoftino(pre => !pre)} />}
      {!isWhiteLabel && <DownloadBanner setShowDownloadBanner={setShowDownloadBanner} />}
      <BottomNavigation data-sentry-element="BottomNavigation" data-sentry-source-file="NavigationBar.tsx" />
    </Box>;
};
export default NavigationBar;